/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Analytical_Thinking18Inputs */

const en_job_form_enum_analytical_thinking18 = /** @type {(inputs: Job_Form_Enum_Analytical_Thinking18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytical Thinking`)
};

const de_job_form_enum_analytical_thinking18 = /** @type {(inputs: Job_Form_Enum_Analytical_Thinking18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytisches Denken`)
};

/**
* | output |
* | --- |
* | "Analytical Thinking" |
*
* @param {Job_Form_Enum_Analytical_Thinking18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_analytical_thinking18 = /** @type {((inputs?: Job_Form_Enum_Analytical_Thinking18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Analytical_Thinking18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_analytical_thinking18(inputs)
	return en_job_form_enum_analytical_thinking18(inputs)
});
export { job_form_enum_analytical_thinking18 as "job_form_enum_ANALYTICAL_THINKING" }